import { CanDeactivateFn } from '@angular/router';

// Pantallas con formulario que deben avisar antes de salir con cambios sin
// guardar. canDeactivate() devuelve true si se puede salir (sin cambios o el
// usuario confirmó descartarlos).
export interface HasUnsavedChanges {
  canDeactivate(): boolean | Promise<boolean>;
}

export const unsavedChangesGuard: CanDeactivateFn<HasUnsavedChanges> = (component, _route, _state, nextState) => {
  // Cierre de sesión / sesión expirada: no se bloquea con el diálogo.
  if (nextState?.url.startsWith('/auth')) return true;
  return component?.canDeactivate ? component.canDeactivate() : true;
};
